import React from 'react';

function NullQuestionResponse() {
  return <div>NullQuestionResponse</div>;
}

export default NullQuestionResponse;
